import { createContext, useState } from 'react';

export const InterviewContext = createContext();

const CONSENT_KEY = 'interview_consent_given';

const InterviewContextProvider = ({ children }) => {

    const searchParam = new URLSearchParams(window.location.search);
    const applicantId = searchParam.get('applicant_id');
    const jobId = searchParam.get('job_id');

    // Persist consent across refresh so resume skips consent screen
    const [consent, setConsent] = useState(() => sessionStorage.getItem(CONSENT_KEY) === 'true');
    const [questionIndex, setQuestionIndex] = useState(0);
    const [totalQuestions, setTotalQuestions] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [isInterviewCompleted, setIsInterviewCompleted] = useState(false);

    const consentAccepter = () => {
        sessionStorage.setItem(CONSENT_KEY, 'true');
        setConsent(true);
    };
    const updateQuestionIndex = () => setQuestionIndex(pre => pre + 1);
    const updateInterviewStatusToEnd = () => {
        sessionStorage.removeItem(CONSENT_KEY);
        setIsInterviewCompleted(true);
    };

    return <InterviewContext.Provider
        value={{
            consent,
            consentAccepter,
            applicantId,
            jobId,
            questionIndex,
            setQuestionIndex,
            totalQuestions,
            setTotalQuestions,
            uploading,
            setUploading,
            isInterviewCompleted,
            updateInterviewStatusToEnd,
            updateQuestionIndex,
        }}>
        {children}
    </InterviewContext.Provider>;
};

export default InterviewContextProvider;
